var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPropertyIconHotel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(471 773)",
    fill: "red"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-471 -773)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.715,3a.57.57,0,1,0,0,1.139h3.038a.57.57,0,1,0,0-1.139ZM9.233,5.278A7.589,7.589,0,0,0,1.667,12.6a1.7,1.7,0,0,0,.542,3.307H16.258A1.7,1.7,0,0,0,16.8,12.6,7.589,7.589,0,0,0,9.233,5.278Zm0,1.139a6.429,6.429,0,0,1,6.417,6.075H2.816A6.429,6.429,0,0,1,9.233,6.417ZM2.209,13.632H16.258a.57.57,0,1,1,0,1.139H2.209a.57.57,0,0,1,0-1.139Z",
    transform: "translate(471.767 773.937)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyIconHotel);
export default __webpack_public_path__ + "static/media/property-icon-hotel.4337641e6e4c20d4905334d8250bf3f1.svg";
export { ForwardRef as ReactComponent };